import { G2WView } from './G2WView';
export class G2SEmbeddedView extends G2WView {
  constructor(g2sEmbeddedView = {}) {
    super(g2sEmbeddedView);
    this._sourceEmbeddedLink = g2sEmbeddedView.sourceEmbeddedLink;
  }
  set sourceEmbeddedLink(value) {
    this._sourceEmbeddedLink = value;
  }
  get sourceEmbeddedLink() {
    return this._sourceEmbeddedLink;
  }
}



// WEBPACK FOOTER //
// ./src/Model/Views/G2SEmbeddedView.js